import './Footer.css';

const LOGO_BEE = `${process.env.PUBLIC_URL}/logos/logo-branca-abelha.svg`;
const LOGO_TEXT = `${process.env.PUBLIC_URL}/logos/logo-branca-texto.svg`;

const Footer = () => (
  <footer className="footer">
    <div className="footer__content">

      <div className="footer__logo">
        <img src={LOGO_BEE} alt="" aria-hidden="true" className="footer__logo-bee" />
        <img src={LOGO_TEXT} alt="Gerenciar" className="footer__logo-text" />
      </div>

      <span className="footer__divider" aria-hidden="true" />

      <span className="footer__copy">
        © {new Date().getFullYear()} · Todos os direitos reservados
      </span>

    </div>
  </footer>
);

export default Footer;
